module.exports = __webpack_public_path__ + "static/media/polonium_network_event_placeholder_16.a547abf6.png";